import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAdminNotifications } from '../components/AdminNotifications';
import { hasPermission, hasAnyPermission, PERMISSION_IDS } from '../utils/permissions';
import { log } from '../utils/logger';

/**
 * @param {{ anyOf?: number[] }} [options]
 * Si `anyOf` está definido, basta con uno de esos permisos (p. ej. panel logística).
 * Sin opciones: PANEL_ADMIN o TESTER (comportamiento histórico).
 */
const useAdminGuard = (options = {}) => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const { notify } = useAdminNotifications();
  const { anyOf } = options;

  useEffect(() => {
    if (!token || !user) {
      notify({
        title: 'Sesión requerida',
        message: 'Por favor inicia sesión para acceder al panel administrativo.',
        variant: 'warning',
      });
      navigate('/401', { replace: true });
      return;
    }

    const hasAccess = Array.isArray(anyOf) && anyOf.length > 0
      ? hasAnyPermission(user, anyOf)
      : hasPermission(user, PERMISSION_IDS.PANEL_ADMIN)
        || hasPermission(user, PERMISSION_IDS.TESTER);

    if (!hasAccess) {
      if (process.env.NODE_ENV === 'development') {
        log('[useAdminGuard] Access denied:', {
          user,
          permissionIds: user?.permissionIds,
          anyOf,
          hasAccess,
        });
      }

      notify({
        title: 'Permisos insuficientes',
        message: 'No tienes los permisos necesarios para acceder al panel administrativo.',
        variant: 'error',
      });
      navigate('/403', { replace: true });
    }
  }, [navigate, notify, token, user, anyOf]);

  return { user, token };
};

export default useAdminGuard;
